import React, { useState, useRef, useEffect } from 'react';
import {languages} from "../../utils/ListItems/languages";
import lineIcon from '../../assets/icons/line.png';
import dropDownIcon from '../../assets/icons/dropdownIcon.png';
import {useTranslation} from "react-i18next";
import './style.scss';

const CustomDropdown = () => {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState({ prefix: 'A', code: 'en', name: 'English' },);
    const dropdownRef = useRef(null);

    // Toggle dropdown open/close
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    // Select an option
    const selectOption = (option) => {
        i18n.changeLanguage(option.code).then();
        const textElements = document.querySelectorAll('.text-container');

        textElements.forEach((element) => {
            element.dir = option.code === 'ar' ? 'rtl' : 'ltr';
        });
        setSelectedOption(option);
        setIsOpen(false);
    };

    // Close dropdown if clicked outside
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    // Add event listener for clicks outside
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="custom-dropdown" ref={dropdownRef}>
            <div className="dropdown-header" onClick={toggleDropdown}>
                <span className={'prefix-circle'}>{selectedOption.prefix}</span>
                <span>{selectedOption ? selectedOption.name : '-- Choose a language --'}</span>
                <span><img alt={'line-icon'} height={38} src={lineIcon}/></span>
                {/*<span className={`dropdown-icon ${isOpen ? 'open' : ''}`}>▼</span>*/}
                <span className={`dropdown-icon ${isOpen ? 'open' : ''}`}>
                    <img width={25} height={14} src={dropDownIcon} alt={"dropdown"}/>
                </span>
            </div>

            {isOpen && (
                <div className="dropdown-list">
                    {languages.map((option) => (
                        <div
                            key={option.code}
                            className="dropdown-item"
                            onClick={() => selectOption(option)}
                        >
                            <span className={'prefix-circle'}>{option.prefix}</span>
                            <span>{option.name} | {option.nativeName}</span>
                            <hr className="styled-hr" />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomDropdown;
